import api, { request } from '../../../api';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { IStandingsStore } from './store';

export interface IStandingsActions extends IActionGroup {
  getByClub: (clubId: number) => { standing?: IStandingsStore; errors?: IErrorsStore };
  getByEvent: (eventId: number) => { standing?: IStandingsStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  getByClub: async (state: IStore, clubId: number) => {
    const response = await request.get(`${api.standings}events/?club_id=${clubId}`);

    if (response.error) {
      return { errors: { standings: { msg: 'Error retrieving the standings by clubs list.' } } };
    }

    return {
      standings: {
        ...state.standings,
        byClub: {
          ...state.standings.byClub,
          [clubId]: response
        }
      }
    };
  },
  getByEvent: async (state: IStore, eventId: number) => {
    const response = await request.get(`${api.standings}rounds/?event_id=${eventId}`);

    if (response.error) {
      return { errors: { standings: { msg: 'Error retrieving the standings by events list.' } } };
    }

    return {
      standings: {
        ...state.standings,
        byEvent: {
          ...state.standings.byEvent,
          [eventId]: response
        }
      }
    };
  }
};

export default actions;
